"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Determine if the WinningHand is a WinByDoubleKong (Chinese: 槓上自摸).
 * @param inputWinningHand WinningHand to be evaluated.
 * @param config Configuration for Faan Calculation.
 * @returns true if the inputWinningHand is a WinByDoubleKong (Chinese: 槓上自摸).
 */
function isWinByDoubleKong(inputWinningHand, config) {
    if (config === undefined) {
        return false;
    }
    return config.winByDoubleKong;
}
exports.default = isWinByDoubleKong;
